import {Box} from 'platform/foundation';

import {AvailabilityStatus} from '../types/AvailabilityStatus';
import {getAvailabilityStatusColor} from '../utils/getAvailabilityStatusColor';

interface AvailabilityStatusDotProps {
  status: AvailabilityStatus;
}

export function AvailabilityStatusDot(props: AvailabilityStatusDotProps) {
  return (
    <Box
      width={2}
      height={2}
      borderRadius="circular"
      flexShrink={0}
      backgroundColor={getAvailabilityStatusColor(props.status)}
    />
  );
}
